
import {
  CHANGE_REPORT_URL
} from "./report-action-types";



export const changeReportUrl = reportUrl => ({ type: CHANGE_REPORT_URL, reportUrl });




// WEBPACK FOOTER //
// ./src/modules/report/report-action-creators.js